import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContrastIcon from '@mui/icons-material/Contrast';
import EditIcon from '@mui/icons-material/Edit';
import ErrorIcon from '@mui/icons-material/Error';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import SendIcon from '@mui/icons-material/Send';
import Chip from '@mui/material/Chip';
import type { InvoiceStatus } from 'app-components/flux/transactions/invoicesSelectors';
import type { EstimateStatus } from 'app-components/flux/transactions/transactionsTypes';
import { formatAsAmount } from 'containers/NewReports/components/ReportGrid/AmountCell';
import React from 'react';

type Props = {
  value?: InvoiceStatus | EstimateStatus | 'credit-available';
  paidAmount?: number;
};

export default function InvoiceStatusChip({ value, paidAmount }: Props) {
  let color: 'error' | 'warning' | 'info' | 'success' | 'inactive' | 'pending' | undefined;
  let Icon: React.ReactElement | undefined;
  let label: string | undefined;
  if (value === 'overdue') {
    color = 'error';
    Icon = <ErrorIcon />;
    label = 'Overdue';
  } else if (value === 'draft') {
    color = 'inactive';
    Icon = <EditIcon />;
    label = 'Draft';
  } else if (value === 'partial') {
    color = 'warning';
    Icon = <ContrastIcon />;
    label = paidAmount ? `${formatAsAmount(paidAmount, false)} Paid` : 'Partial';
  } else if (value === 'sent') {
    color = 'info';
    Icon = <SendIcon />;
    label = 'Sent';
  } else if (value === 'paid') {
    color = 'success';
    Icon = <CheckCircleIcon />;
    label = 'Paid';
  } else if (value === 'credit-available') {
    color = 'pending';
    label = 'Credit Available';
    Icon = <MonetizationOnIcon />;
  } else if (value === 'PENDING') {
    color = 'pending';
    Icon = <PendingActionsIcon />;
    label = 'Pending';
  } else if (value === 'ACCEPTED') {
    color = 'success';
    Icon = <CheckCircleIcon />;
    label = 'Accepted';
  } else if (value === 'DECLINED') {
    color = 'error';
    Icon = <ErrorIcon />;
    label = 'Declined';
  } else if (value === 'CONVERTED') {
    color = 'success';
    Icon = <PublishedWithChangesIcon />;
    label = 'Converted';
  } else if (value === 'EXPIRED') {
    color = 'warning';
    Icon = <ContrastIcon />;
    label = 'Expired';
  }

  return !label ? null : <Chip color={color} icon={Icon} label={label} size='small' variant='tonal' />;
}
